import React, { useState, useContext } from 'react';
import { Query } from 'react-apollo';
import { subjectMembersQuery } from '../../../../queries/subjects';
import {
  SubjectMembersQuery,
  SubjectMembersQueryVariables
} from '../../../../queries/__generated__/SubjectMembersQuery';
import { Card } from '../../../ui';
import { Subject } from '../../subject/types';
import AddMemberToSubjectModal from './AddMemberToSubjectModal';
import MemberList from './MemberList';
import { useQuery } from 'react-apollo-hooks';
import { Loading, ErrorScreen } from '../../../utils';
import { UserContext } from '../../../../context/UserContext';

interface SubjectMemberListProps {
  subject: Subject;
  userCanAdmin: boolean;
}

const SubjectMemberList: React.FC<SubjectMemberListProps> = ({ subject, userCanAdmin }) => {
  const { user } = useContext(UserContext);

  const [showInviteModal, setShowInviteModal] = useState(false);
  const { data, loading, error } = useQuery<SubjectMembersQuery, SubjectMembersQueryVariables>(
    subjectMembersQuery,
    { variables: { input: { subjectId: subject.id } } }
  );
  if (loading) return <Loading />;
  if (error) return <ErrorScreen error={error.message} />;

  const subjectMembers = data!.subjectMembers;
  const activeMember = subjectMembers.filter(member => member.member.user.id === user.id)[0];
  const userIsAdmin = activeMember.roleType.toUpperCase() === 'ADMIN';

  return (
    <>
      <Card className="pa4 mb2">
        <div className="flex justify-between items-baseline mb3">
          <h2 className="f5 fw6 mv0">Contributors</h2>

          {userCanAdmin && (
            <button
              className="f7 blue hover-navy"
              onClick={() => setShowInviteModal(true)}
              data-testid="invite-member-button"
            >
              Add Contributor
            </button>
          )}
        </div>

        <MemberList subject={subject} subjectMembers={subjectMembers} userIsAdmin={userIsAdmin} />
      </Card>

      {showInviteModal && (
        <AddMemberToSubjectModal
          closeModal={() => setShowInviteModal(false)}
          subject={subject}
          subjectMembers={subjectMembers}
        />
      )}
    </>
  );
};

export default SubjectMemberList;
